import { createActionName } from "../../../utility"

export const reducerName = "themes"

export const THEME = createActionName(reducerName, "THEME")
export const THEMES = createActionName(reducerName, "THEMES")
